import { render, staticRenderFns } from "./display-show.vue?vue&type=template&id=505a3a14&scoped=true&"
import script from "./display-show.vue?vue&type=script&lang=js&"
export * from "./display-show.vue?vue&type=script&lang=js&"
import style0 from "./display-show.vue?vue&type=style&index=0&id=505a3a14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505a3a14",
  null
  
)

export default component.exports